<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc">God, Freedom and Human Dignity</h2>
<p class="h3">Embracing a God-Centered Identity in a Me-Centered Culture</p>
<p class="first"> </p>
<p class="h3">Ron Highfield</p>
<p class="first"> </p>
<p class="firstcenter"><img alt="IVP Books Imprint" src="Images/IVP_Academic_Quarter.jpg"/></p>
<p class="firstcenter"><a href="http://www.IVPress.com/academic" target="_blank">www.IVPress.com/academic</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?18e7eb47